import { AddChallengeToPatientPayload } from '_api/types';
import { DaysOfWeekOptions, TargetSideOptions } from '_constants';
import {
  InputField,
  MultipleCheckboxField,
  PatientInstructionsField,
  SelectField,
} from 'components/molecules/formFields';

import { FormBuilder } from './form-builder';
import { AddToPatientProps } from './types';

export const EditChallengeToPatientProfileForm = ({
  initValue,
  onSubmit,
  onUpdate,
}: AddToPatientProps<AddChallengeToPatientPayload>) => {
  const update = async (key: any, arg: any) => {
    if (key === 'schedule') {
      onUpdate('perWeek', arg.length);
    }
    if (key === 'perWeek') {
      switch (arg) {
        case 0:
          onUpdate('schedule', []);
          break;
        case 1:
          onUpdate('schedule', ['M']);
          break;
        case 2:
          onUpdate('schedule', ['TU', 'TH']);
          break;
        case 3:
          onUpdate('schedule', ['M', 'W', 'F']);
          break;
        case 4:
          onUpdate('schedule', ['M', 'TU', 'TH', 'F']);
          break;
        case 5:
          onUpdate('schedule', ['M', 'TU', 'W', 'TH', 'F']);
          break;
        case 6:
          onUpdate('schedule', ['M', 'TU', 'W', 'TH', 'F', 'SA']);
          break;
        default:
          onUpdate('schedule', ['M', 'TU', 'W', 'TH', 'F', 'SA', 'SU']);
      }
    }
    onUpdate(key, arg);
  };

  const formField = [
    {
      component: SelectField,
      fieldKey: 'defaultTargetSide',
      label: 'TARGET SIDE',
      options: TargetSideOptions || [],
      xs: 2,
      required: true,
    },
    {
      component: InputField,
      fieldKey: 'perWeek',
      label: 'Per Week',
      type: 'number',
      xs: 2,
      maxValue: 7,
      validation: {
        validate: (currentValue: number) =>
          currentValue > 0 || 'Value must be greater than 0.',
      },
    },
    {
      component: PatientInstructionsField,
      fieldKey: 'instructionList',
      label: 'Instructions',
      xs: 12,
      required: true,
      validation: {
        validate: (instructions: string[]) =>
          instructions?.some((instruction) => instruction.trim().length > 0) ||
          'At least one instruction is required.',
      },
    },
    {
      component: MultipleCheckboxField,
      fieldKey: 'schedule',
      label: '',
      options: DaysOfWeekOptions,
      xs: 12,
    },
  ];

  return (
    <FormBuilder
      initValues={initValue}
      formFields={formField}
      onSubmit={onSubmit}
      onUpdate={update}
      hideSubmit={true}
    />
  );
};
